export class ComponentEntryComplexityRole {
  id!: number
  modifierId!: number
  modifierFormulaType!: string
  name!: string
  complexity!: string
  disciplineTypeName!: string
  rateCardNameAndVersion!: string
  componentModifierName?: string
  formula?: string
}
